import React from 'react';
import { TankYouTextContainer, ThankYouWrapper } from './ThankYouWithLink.styles';
import Paragraph from 'src/elements/typography/paragraph';
import FadeInAnimationWrapper from 'src/elements/animation/fade-in/FadeInAnimationWrapper';
import Heading from 'src/elements/typography/heading';
import LinkBranded from 'src/elements/links/2023_Q4/LinkBranded';

const ThankYouWithLink = (): JSX.Element => {
  return (
    <ThankYouWrapper>
      <FadeInAnimationWrapper>
        <TankYouTextContainer>
          <Heading
            standardSize='3.375'
            weight={700}
            align='center'
            text='You’re in!'
          />
          <Paragraph
            text={`👇👇👇`}
            standardSize='1.5'
            align='center'
          />
          <LinkBranded
            url={`/peoplemagic/masterclass`}
            text={'Go to the Masterclass'}
            colorScheme='Sunshine'
            standardSize='1'
            className='thank-you-masterclass-link'
          />

          <Paragraph
            text={`The link is also in your inbox`}
            standardSize='1.5'
            weight='light'
            align='center'
          />
        </TankYouTextContainer>
      </FadeInAnimationWrapper>
    </ThankYouWrapper>
  );
};

export default ThankYouWithLink;
